module.exports = __webpack_public_path__ + "media/images/restaurant/areas/northern_honshu_m-a92a62ad3edbf1f4227af73ca20ea388.png";